import { Component, Inject, OnInit } from '@angular/core';
import { FormulareService } from '../../formulare/formulare.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup } from '@angular/forms';
import { Auftrag } from '../../state/auftrag.model';

@Component({
  selector: 'app-dialog-checkliste-lkt-bioflow',
  templateUrl: './dialog-checkliste-lkt-bioflow.component.html',
  styleUrls: ['./dialog-checkliste-lkt-bioflow.component.scss'],
})
export class DialogChecklisteLktBioflowComponent implements OnInit {
  form: FormGroup;
  auftrag: Auftrag;

  constructor(@Inject(MAT_DIALOG_DATA) dialogData, formulareService: FormulareService) {
    const { formData = {}, auftrag } = dialogData;

    if (!auftrag) {
      throw new Error('Kein Auftrag!');
    }

    this.auftrag = auftrag;

    this.form = formulareService.checklisteBioFlow();
    this.form.patchValue(formData);
  }

  ngOnInit() {}
}
